import * as z from "zod";

export const getCommerceCloudCartridgeStatus = {
  name: "getCommerceCloudCartridgeStatus" as const,
  input: z.null(),
  output: z.object({
    orderSync: z.object({
      ok: z.boolean(),
      lastOrderAt: z.date().nullable(),
      detail: z.string(),
    }),
    storefrontEmbed: z.object({ ok: z.boolean(), detail: z.string() }),
  }),
};
